export const resolveAccountId = async ({ dispatch, rootGetters }) => {
  let currentUser = rootGetters['auth/getCurrentUser']
  if (!currentUser) {
    await dispatch('auth/validityCheck', null, { root: true })
    currentUser = rootGetters['auth/getCurrentUser']
  }
  return currentUser?.accounts?.[0]?.id
}
